import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Alert } from '../../../shared/alert.model';
import { MessageService } from '../../../shared/message.service';
import { EventEmitterWithObservable } from '../../../shared/EventEmitterWithValueReturned';
import { TransactionFailedRecord } from '../../model/Transaction';
import { MessageType } from '../../../shared/messageType';
import { getAlertMessage } from '../../../shared/api-loaders';
import { finalize } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
    selector: 're-process-failed-users',
    templateUrl: './process-failed-users.component.html',
    styleUrls: ['./process-failed-users.component.scss'],
    standalone: false
})
export class ProcessFailedUsersComponent implements OnInit {

  constructor(private messageService: MessageService, private route: ActivatedRoute, private router: Router ) { }
  ngOnInit(): void {
    this.load();
  }

  alert: Alert;

  @Output()
  loaded = new EventEmitter<EventEmitterWithObservable>();

  @Input()
  title: "";

  @Input()
  hideSsoId: boolean = false;

  data: TransactionFailedRecord[]

  load() {
    this.messageService.send(MessageType.ProcessingOn);

    let data = new EventEmitterWithObservable();
    this.loaded.emit(data);
    if (!data.ReturnValue)
      throw 'loaded event didnt get the ReturnValue observable';


    this.data = [];
    this.alert = null;

    data.ReturnValue.pipe(finalize(() => this.messageService.send(MessageType.ProcessingOff)))
      .subscribe(x => {
        this.data = x;
      }, e => this.alert = getAlertMessage(e));

  }

  back() {
    this.router.navigate([ "../.." ], { relativeTo: this.route })
  }
}
